import { computed, effect, Injectable, signal } from '@angular/core';
import { firstValueFrom, of, single } from 'rxjs';
import { notifications } from '../../../shared/data/notifications-data';
import { AppNotification } from '../models/notifications';

@Injectable({
    providedIn: 'root',
})
export class NotificationsService {

    private readonly STORAGE_KEY = 'blueocean_read_notifications';

    currentNotifications = signal<AppNotification[]>([]);
    selectedNotification = signal<AppNotification | null>(null);

    readonly readNotificationIds = signal<Set<string>>(this.loadFromStorage());

    readonly loadingNotifications = signal(false);
    readonly notificationsError = signal<string | null>(null);


    constructor() {
        this.loadNotifications();
    }

    private loadFromStorage(): Set<string> {
        try {
            const raw = localStorage.getItem(this.STORAGE_KEY);
            return new Set(raw ? JSON.parse(raw) : []);
        } catch {
            return new Set();
        }
    }

    getNotifications() {
        return of(notifications);
    }

    async loadNotifications() {
        console.log("LOADING NOTIFICATIONS");
        this.loadingNotifications.set(true);
        this.notificationsError.set(null);
        try {
            const n = await firstValueFrom(this.getNotifications())
            this.currentNotifications.set(n);
            console.log(n);
        } catch (err: any) {
            console.error('Error loading notifications:', err);
            this.notificationsError.set(err.message || 'Error loading notifications')
        } finally {
            this.loadingNotifications.set(false);
        }
    }

    readNotificationId(id: string) {
        const currentSet = new Set(this.readNotificationIds());
        currentSet.add(id);
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify([...currentSet]));
        this.readNotificationIds.set(currentSet);
    }

    toggleReadStatus(id: string) {
        const currentSet = new Set(this.readNotificationIds());
        if (currentSet.has(id)) {
            currentSet.delete(id);
        } else {
            currentSet.add(id);
        }

        // Update Signal
        this.readNotificationIds.set(currentSet);
        // Sync to Storage
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify([...currentSet]));
    }

    isRead(id: string): boolean {
        return this.readNotificationIds().has(id);
    }
}
